import React,{useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import {buyerConfirmDeliveryOrder} from '../../services/deliveryConfirmationService';

const {FiCheckCircle,FiLoader}=FiIcons;

const BuyerDeliveryConfirmationButton=({order,onConfirmed})=>{
  const [isConfirming,setIsConfirming]=useState(false);
  const [error,setError]=useState('');

  if (
    !order
    || order.status!=='ready'
    || order.delivery_method!=='delivery'
  ) {
    return null;
  }

  const handleConfirm=async(event)=>{
    event.stopPropagation();

    if (!window.confirm('Confirm that you received this delivery?')) {
      return;
    }

    setIsConfirming(true);
    setError('');

    try {
      const result=await buyerConfirmDeliveryOrder(order.id,{
        source:'buyer_order_details',
        confirmed_at:new Date().toISOString()
      });

      window.dispatchEvent(new Event('sohlocal:orders-changed'));
      await onConfirmed?.(result);
    } catch (requestError) {
      setError(requestError.message || 'Unable to confirm delivery.');
    } finally {
      setIsConfirming(false);
    }
  };

  return (
    <div className="mt-4 w-full">
      <div className="mb-4 rounded-2xl border border-indigo-100 bg-indigo-50 p-4">
        <p className="text-sm font-bold text-indigo-900">
          Confirm that you received this delivery, or report an issue with the order.
        </p>
      </div>

      <div className="flex flex-wrap justify-end gap-3">
        <button
          type="button"
          onClick={handleConfirm}
          disabled={isConfirming}
          className="flex items-center justify-center rounded-xl bg-indigo-600 px-5 py-3 text-[10px] font-black uppercase tracking-widest text-white disabled:opacity-50"
        >
          {isConfirming ? (
            <SafeIcon icon={FiLoader} className="mr-2 animate-spin" />
          ) : (
            <SafeIcon icon={FiCheckCircle} className="mr-2" />
          )}
          Mark as Received
        </button>
      </div>

      {error && (
        <p className="mt-2 text-right text-xs font-bold text-red-600">
          {error}
        </p>
      )}
    </div>
  );
};

export default BuyerDeliveryConfirmationButton;
